import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import QA from '../../../../src/constants/QATags';
import ButtonT3 from '../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../components/lib/ButtonT3/constants';
import MiniHeader from '../../../components/lib/MiniHeader/MiniHeader';
import { BlueBarButtons, ReloadMessageStrings } from '../../../constants/BlueBar';

import './BlueBar.scss';

const buttonTypes = Object.keys(BlueBarButtons).reduce(
  (y, z) => y.push(BlueBarButtons[z]) && y,
  [],
);

class BlueBar extends React.Component {
  static propTypes = {
    message: PropTypes.node.isRequired,
    background: PropTypes.string,
    buttonType: PropTypes.oneOf(buttonTypes),
    onClose: PropTypes.func,
    buttonRight: PropTypes.bool,
  };

  reloadPage = () => {
    window.location.reload(false);
  };

  getButton = () => {
    switch (this.props.buttonType) {
      case BlueBarButtons.PANDORA_PLUS:
        return <div className='BlueBar__button'>click here</div>;
      case BlueBarButtons.RELOAD:
        return (
          <ButtonT3 size={ButtonT3Size.SMALL} theme={ButtonT3Theme.WHITE} onClick={this.reloadPage}>
            <FormattedMessage {...ReloadMessageStrings.reloadButton} />
          </ButtonT3>
        );
      default:
        return null;
    }
  };

  render() {
    const message = this.props.message.id ? (
      <FormattedMessage {...this.props.message} />
    ) : (
      this.props.message
    );
    return (
      <MiniHeader
        color={this.props.background}
        className='BlueBar'
        showing={true}
        onClose={this.props.onClose}
      >
        {!this.props.buttonRight && this.getButton()}
        <div className='BlueBar__message' data-qa={QA.MB}>
          {message}
        </div>
        {this.props.buttonRight && this.getButton()}
      </MiniHeader>
    );
  }
}

export default BlueBar;
